export const LOADER_VISIBLE = 'LOADER_VISIBLE'

export const setLoaderVisibility = (isLoaderVisible) => ({ type: LOADER_VISIBLE, isLoaderVisible })